import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export interface Job {
  id: string;
  job_number: string | null;
  status: string;
  property_address: string;
  property_city: string | null;
  property_state: string | null;
  property_zip: string | null;
  property_type: string | null;
  owner_name: string | null;
  owner_phone: string | null;
  owner_email: string | null;
  estimated_value: number | null;
  created_at: string | null;
  updated_at: string | null;
  insurance_company: string | null;
  claim_number: string | null;
  notes: string | null;
}

export const useJobs = (orgId?: string) => {
  const [jobs, setJobs] = useState<Job[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadJobs = async () => {
    if (!orgId) {
      setJobs([]);
      setError(null);
      setLoading(false);
      return;
    }

    setJobs([]);
    setLoading(true);
    setError(null);
    
    try {
      const { data, error: fetchError } = await supabase
        .from('jobs')
        .select('*')
        .eq('org_id', orgId)
        .order('created_at', { ascending: false });

      if (fetchError) throw fetchError;
      setJobs(data || []);
    } catch (err: any) {
      console.error("Error loading jobs:", err);
      setError(err.message);
      toast.error("Failed to load jobs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadJobs();
  }, [orgId]);

  return { jobs, loading, error, refetch: loadJobs };
};
